import Box from "@storeblocks/box";
import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { useTexts } from "Components/TextContext";
import { AdviceType } from "Store/advicePDF/interfaces";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { useAdviceType } from "Store/akaAdvice/akaAdviceHooks";
import { updatePriceCalculationFormState } from "Store/priceCalculation/priceCalculationSlice";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import { ADVICE_PRICE_STEP } from "../../adviceSteps";
import { getPercentOfPDFDocumentCommentSpaceUsed } from "../utils";
import { AkaAdvicePriceFormValues } from "./interfaces";

type CommentId =
  | "deathAdviceComment"
  | "disabilityAdviceComment"
  | "criticalIllnessAdviceComment";

interface Props {
  commentId: CommentId;
  formProps: FormikProps<AkaAdvicePriceFormValues>;
  label: string;
}

export const AdviceCardComment = ({
  commentId,
  formProps,
  label,
}: Props): React.ReactElement | null => {
  const isAdvisor = useIsAdvisorSelector();
  const dispatch = useDispatch();
  const adviceType = useAdviceType();
  const { getText } = useTexts();
  const documentCommentSpaceUsed = getPercentOfPDFDocumentCommentSpaceUsed(
    formProps.values,
  );

  const handleAdviceCommentChange = (value: string): void => {
    dispatch(
      updatePriceCalculationFormState({
        stepId: ADVICE_PRICE_STEP.id,
        formState: {
          ...formProps.values,
          [commentId]: value,
        },
      }),
    );
  };

  if (!isAdvisor) {
    return null;
  }

  return (
    <>
      <Box marginTop="16px" className="data-hj-suppress">
        <Input
          id={commentId}
          name={commentId}
          label={label}
          hint="Denne informasjonen legges inn som en del av dokumentasjonen til kunden."
          as="textarea"
          fluid
          rows={3}
          error={getError(commentId, formProps)}
          onChange={(e) => {
            handleAdviceCommentChange(e.target.value);
          }}
          inputMode={InputMode.TEXT}
          debounced
        />
      </Box>
      {adviceType === AdviceType.INDIVIDUAL &&
        formProps.values[commentId] &&
        documentCommentSpaceUsed > 100 &&
        getText("advicepage.commentspaceusedmessage", {
          variables: { percentageUsed: documentCommentSpaceUsed },
        })}
    </>
  );
};
